/* eslint-disable no-script-url */
import PAImage from "component/design-system/images/PAImage";
import useScreenSize from "hoc/useScreenSize";
import { memo, useState } from "react";
import { getImageAlt } from "util/product/getImageAlt";
import { ImageA } from "../StyleComponent";
import styles from "./style.module.scss";

const fallBackImage = `${process.env.NEXT_PUBLIC_ROOT_URL}/images/common/image-not-available_16051144.png`;
const fallBackImageAlt = "Image not found";

function ThumbnailImage(props: any) {
  const {
    setSelectedImage, image, index, selectedImage, aTagStyle, imageTitle, type, imgStyle, className = "", productLineVideos = [], imageSize = 80,
  } = props;
  const selectedIndex = productLineVideos.length > 0 && index > 2 ? index - productLineVideos.length : index;
  const [imageError, setImageError] = useState(false);
  const actionProps = selectedImage === selectedIndex ? {} : {
    onClick: () => setSelectedImage(selectedIndex),
    onMouseEnter: () => setSelectedImage(selectedIndex),
  };

  const [isMobile] = useScreenSize();

  if (type === "spinning") {
    return (
      <ImageA
        active={selectedImage === selectedIndex}
        href="javascript:void(0)"
        style={aTagStyle}
        className={styles.spinnginThumbnailATag}
        {...actionProps}
      >

        <PAImage
          alt={imageError ? fallBackImageAlt : getImageAlt(image, imageTitle)}
          src={imageError ? fallBackImage : image}
          className={`${styles.PAImageImg}`}
          onError={() => setImageError(true)}
          width={isMobile ? 55 : imageSize}
          height={isMobile ? 55 : imageSize}
        />

        <span>360°</span>
      </ImageA>
    );
  }
  const altText = `Purchase Top-Quality ${getImageAlt(image, imageTitle)}`;
  return (
    <ImageA
      active={selectedImage === selectedIndex}
      href="javascript:void(0)"
      style={aTagStyle}
      {...actionProps}
      className={className}
    >

      <PAImage
        alt={imageError ? fallBackImageAlt : altText}
        title={altText}
        src={imageError ? fallBackImage : image}
        width={isMobile ? 55 : imageSize}
        height={isMobile ? 55 : imageSize}
        className={styles.defautThumbnailImg}
        onError={() => setImageError(true)}
        style={imgStyle}
      />
    </ImageA>
  );
}

export default memo(ThumbnailImage);
